// Public API exports for the brand-menu feature
export { CATEGORIES_PER_PAGE } from './constants';
export { getCategoryWithProducts } from './api/get-category-with-products';
export type { GetCategoryWithProductsParams } from './api/get-category-with-products';
export { buildSections, buildMenuItems, resolveTitle } from './model/build-menu';
export { useCategoryWithProducts, useBrandMenuContext } from './model/use-category-with-products';
export type { UseCategoryWithProductsParams } from './model/use-category-with-products';
export type {
  ICategoryWithProducts,
  IChildCategory,
  IResponse,
  Section,
  MenuItem,
} from './types';
